import { ChangeEvent, FocusEvent } from "react";
import { formatPhoneNumber } from "shared";
import { FormElement, FormInput } from "../../../components";
import { ValidationErrors } from "../../../ContactInfo.types";
import { CustomerPhone, CustomerPhoneKey } from "../EditPhoneNumber.types";

type EditPhoneNumberFormProps = {
  customerPhone: CustomerPhone;
  changedFields: Set<CustomerPhoneKey>;
  validationErrors: ValidationErrors;
  pending: boolean;

  /** Callback when a field changes */
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;

  /** Callback when a field loses focus */
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
};

export const EditPhoneNumberForm = ({
  customerPhone,
  changedFields,
  validationErrors,
  pending,
  onChange,
  onBlur,
}: EditPhoneNumberFormProps) => {
  const { phone } = customerPhone;

  const getFieldError = (id: CustomerPhoneKey): string | undefined => {
    return changedFields.has(id) ? validationErrors[id] : undefined;
  };

  return (
    <>
      <FormElement<CustomerPhoneKey>
        id="phone"
        label="Phone number"
        required
        showRequiredIndicator={false}
        error={getFieldError("phone")}
      >
        <FormInput
          autoComplete="phone-number"
          maxLength={40}
          onChange={onChange}
          onBlur={onBlur}
          value={formatPhoneNumber(phone)}
          readOnly={pending}
          type="tel"
          title="Format: (123) 456-7890"
        />
      </FormElement>

      {/* This only exists so the form can be submitted via the enter key. */}
      <input type="submit" value="Submit" style={{ display: "none" }} />
    </>
  );
};
